import React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getRoom, getRoomIDsSorted } from './roomsSlice';
import { Button } from '../../components/Button';
import { useTranslation } from 'react-i18next';

import './RoomList.css';

const RoomListItem = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const room = useSelector(state => getRoom(state, props.id), shallowEqual);

  return (
    <tbody>
      <tr>
        <td className="icon" rowSpan="2"><img src={'images/rooms/'+room.filename} alt="Maskot"/></td>
        <td className="name">{room.name} {room.details ? (<i>({room.details})</i>) : null}</td>
        <td className="button" rowSpan="2"><Button onClick={e => dispatch({type: 'action/joinroom', payload: { id: room.id }})}>{t('JOIN')}</Button></td>
      </tr>
      <tr>
        <td>{t('PLAYER_COUNT', {count: room.users_online})}</td>
      </tr>
    </tbody>
  )
}

export const RoomList = () => {
  const roomIDs = useSelector(getRoomIDsSorted, shallowEqual);

  const rooms = roomIDs.map((id) => {
    return <RoomListItem key={id} id={id}/>;
  });

  return (
    <div className="roomList">
      <div className="box">
        <table>
          {rooms}
        </table>
      </div>
    </div>
  );
};